query getCreatedContentsStatistics($isMasterView: Boolean, $childCompanyId: ID) {
  statistics: getCreatedContentsStatistics(isMasterView: $isMasterView, childCompanyId: $childCompanyId) {
    textKindStatistics {
      textKind
      count
    }
    topicStatistics {
      topicName
      count
    }
  }
}
